<template lang="html">
  <nav aria-label="Page navigation example" v-show="totalPage!=1&&totalPage!=0" class="pagination-wrapper">
    <ul class="pagination">
      <li class="page-item"><a class="page-link" @click="changePage(0,1)">上一页</a></li>
      <li v-for="(item, index) in pageList" :key="index"
        :class="['page-item', item === 'ellipsis' ? 'disabled' : '', item !== 'ellipsis' && currentPage == item ? 'active' : '']"
        @click="item !== 'ellipsis' && changePage(item,2)">
        <a v-if="item !== 'ellipsis'" class="page-link">{{item}}</a>
        <span v-else class="page-link">...</span>
      </li>
      <li class="page-item"><a class="page-link" @click="changePage(0,3)">下一页</a></li>
      <li class="page-item page-jump">
        <span class="page-link" style="border: none; padding: 0 8px; display: flex; align-items: center;">
          <input type="number" v-model.number="jumpPage" @keyup.enter="doJump"
            :min="1" :max="totalPage" placeholder="页"
            class="page-jump-input">
          <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="doJump">跳转</button>
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['totalPage', 'currentPage'],
  data() {
    return {
      jumpPage: null
    }
  },
  mounted() {
    this.jumpPage = this.currentPage
  },
  watch: {
    currentPage(val) {
      this.jumpPage = val
    }
  },
  computed: {
    pageList() {
      const total = this.totalPage
      const current = this.currentPage
      if (!total || total <= 0) return []
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1)
      }
      const arr = []
      const showCount = 2
      if (current <= 4) {
        for (let i = 1; i <= Math.min(5, total); i++) arr.push(i)
        if (total > 6) arr.push('ellipsis', total)
      } else if (current >= total - 3) {
        arr.push(1)
        if (total > 6) arr.push('ellipsis')
        for (let i = Math.max(1, total - 4); i <= total; i++) arr.push(i)
      } else {
        arr.push(1, 'ellipsis')
        for (let i = current - showCount; i <= current + showCount; i++) arr.push(i)
        arr.push('ellipsis', total)
      }
      return arr
    }
  },
  methods: {
    changePage(p, type) {
      const Pre = 1
      const Jump = 2
      const Next = 3
      let page
      if (type == Jump) {
        page = p
      } else if (type == Pre) {
        page = (this.currentPage - 1) < 1 ? 1 : this.currentPage - 1
      } else if (type == Next) {
        page = (this.currentPage + 1) > this.totalPage ? this.totalPage : this.currentPage + 1
      }
      this.$emit("catchPage", { p: page })
    },
    doJump() {
      let page = parseInt(this.jumpPage, 10)
      if (isNaN(page) || page < 1) page = 1
      if (page > this.totalPage) page = this.totalPage
      this.jumpPage = page
      this.$emit("catchPage", { p: page })
    }
  }
}
</script>

<style lang="css" scoped>
.pagination-wrapper .page-item .page-link {
  min-height: 32px;
  height: 32px;
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
}
.pagination-wrapper .page-item.disabled .page-link {
  cursor: default;
}
.page-jump-input {
  width: 50px;
  height: 32px;
  padding: 0 8px;
  text-align: center;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-sizing: border-box;
}
.page-jump-input::-webkit-inner-spin-button,
.page-jump-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.page-jump {
  margin-left: 0.5rem;
  border: none !important;
}
.page-jump .page-link {
  height: auto;
  min-height: auto;
  padding: 0 8px;
}
.page-jump .page-link:hover {
  background: transparent;
}
.page-jump .page-link .btn {
  height: 32px;
  line-height: 1;
  padding: 0 0.5rem;
}
.pagination-wrapper .page-item.active .page-link {
  z-index: 2;
  color: #fff;
  background-color: #18a689;
  border-color: #18a689;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue